// extracted by mini-css-extract-plugin
export default {"Wrapper_trade":"Wrapper_trade_Wrapper_trade__voEYu"};